var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cat-images"},_vm._l((_vm.cats),function(cat){return _c('router-link',{key:cat.id,attrs:{"to":("/cats/" + (cat.id))}},[_c('div',{staticClass:"cat-container",style:(("background-image: url(" + (cat.url) + ")"))})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }